import { adminHttpClient } from '../../commons/adminHttpClient'
import { LegalDocument } from '../../../domain/legalDocuments/legalDocuments'

export interface BenefitLegalDocumentsState {
  signed: boolean
  legalDocumentFileUrl: string
  externalResource: boolean
}

export const legalDocumentsStateApi = (planPeriodId?: string): Promise<any> => {
  return adminHttpClient.get(`/AdminDashboard/BenefitPlanDocuments/GetStatus?planPeriodId=${planPeriodId}`)
}

export const getAdminLegalDocuments = (planPeriodId?: string): Promise<LegalDocument[]> => {
  return adminHttpClient.get(`/AdminDashboard/LegalDocuments/AdminDocuments?planPeriodId=${planPeriodId}`)
}

export interface ScheduleALegalDocuments {
  productClassId?: string
  planPeriodId?: string
}

export const getAdminScheduleALegalDocuments = (data: ScheduleALegalDocuments) => {
  return adminHttpClient.get(`/AdminDashboard/LegalDocuments/ScheduleADocument`, data)
}

export interface Exhibit1LegalDocuments {
  planPeriodId: string
}

export const getAdminExhibit1LegalDocuments = (planPeriodId?: string) => {
  return adminHttpClient.get(`/AdminDashboard/LegalDocuments/Exhibit1LegalDocument?planPeriodId=${planPeriodId}`)
}

export const previewLegalDocumentsApi = (url: string) => {
  return adminHttpClient.get(url)
}

export const getDynamicDocument = (apiUrl: string, planPeriodId?: string) => {
  return adminHttpClient.get(`${apiUrl}?planPeriodId=${planPeriodId}`)
}
